import React from "react";
import { formatDistanceToNow } from "date-fns";
import { CardExcerpt, MetaPill, MetaRow, Panel } from "./ForumStyles";

const formatCreatedAt = (value) => {
  if (!value) return "Just now";

  try {
    return formatDistanceToNow(new Date(value), { addSuffix: true });
  } catch (_error) {
    return "Recently";
  }
};

function ReplyItem({ reply }) {
  return (
    <Panel>
      <MetaRow>
        {reply.isBestAnswer ? <MetaPill $accent>Best answer</MetaPill> : null}
        {reply.isTeamReply ? <MetaPill $accent>Mags team</MetaPill> : null}
        <MetaPill>By {reply.authorName || "Anonymous"}</MetaPill>
        <MetaPill>{formatCreatedAt(reply.createdAt)}</MetaPill>
      </MetaRow>
      <CardExcerpt>{reply.body}</CardExcerpt>
    </Panel>
  );
}

export default ReplyItem;
